import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import HfNavigationMenu from '../navigation/HfNavigationMenu';
import HfTopnavbar from '../topnavbar/HfTopnavbar';
import HfFooter from '../footer/HfFooter';
import { HF_CONTENT_PADDING } from '@root/app/shared/theme/layoutConstants';

const HfAppShellLayout: React.FC = () => (
    <Box
        id='wrapper'
        sx={(theme) => ({
            display: 'flex',
            minHeight: '100vh',
            width: '100%',
            overflow: 'hidden',
            bgcolor: theme.palette.hfLayout.sidebar
        })}
    >
        <HfNavigationMenu />
        <Box
            id='page-wrapper'
            component='main'
            sx={(theme) => ({
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minWidth: 0,
                minHeight: '100vh',
                bgcolor: theme.palette.hfLayout.surface
            })}
        >
            <HfTopnavbar />
            <Box
                id='content'
                sx={(theme) => ({
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflow: 'auto',
                    bgcolor: theme.palette.hfLayout.surface,
                    pt: HF_CONTENT_PADDING.top,
                    px: HF_CONTENT_PADDING.horizontal,
                    pb: HF_CONTENT_PADDING.bottom
                })}
            >
                <Outlet />
            </Box>
            <HfFooter />
        </Box>
    </Box>
);

export default HfAppShellLayout;
